import { render, staticRenderFns } from "./users-new.vue?vue&type=template&id=e30b5bac"
import script from "./users-new.vue?vue&type=script&lang=js"
export * from "./users-new.vue?vue&type=script&lang=js"
import style0 from "./users-new.vue?vue&type=style&index=0&id=e30b5bac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports